<ng-container>
<dk-ctl-sablon #sablonCmp
    [isReadOnly]="isReadOnly" [labelText]="labelText" [labelMode]="labelMode" [title]="title" [code]="code"
    (handleValueChange)="handleValueChange($event)" (codeChanges)="code = $event" [warningMessage]="warningMessage"
    (searchClick)="searchClick()" [validationRules]="validationRulesMap" [validationV2]="validationV2"
    (clear)="clear()">
</dk-ctl-sablon>  
<dx-popup *ngIf="crudPopupVisible"
[title]="piHesapTuru===1?'Gelir Arama':harcamaKodu===null && piHesapTuru === 2?'Gider Arama':''"
[resizeEnabled]="false"
[hideOnOutsideClick]="false"
[showCloseButton]="true"
[(visible)]="crudPopupVisible"
(onHiding)="closePopupAfter($event, sablonCmp)"
>
    <dk-ctl-teb-ekonomik-arama
    (closePopup)="closePopupAfter($event, sablonCmp)"
    ></dk-ctl-teb-ekonomik-arama>
</dx-popup>
<dx-toast [(visible)]="toastVisible" type="error" [message]="toastMessage">
</dx-toast>
</ng-container>
